import { useState, useRef, useEffect } from 'react';

function DatePicker({ startDate, onDateChange, dateDisplay }) {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [tempDate, setTempDate] = useState(startDate.format('YYYY-MM-DD'));
  const datePickerRef = useRef(null);
  const inputRef = useRef(null);

  // Close date picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
        setShowDatePicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Update temp date when startDate changes
  useEffect(() => {
    setTempDate(startDate.format('YYYY-MM-DD'));
  }, [startDate]);

  const handleDatePickerChange = (e) => {
    const newDate = e.target.value;
    setTempDate(newDate);
    // Apply the date change immediately when a date is selected
    if (newDate) {
      onDateChange(newDate);
      setShowDatePicker(false);
    }
  };

  const handleDatePickerBlur = (e) => {
    // Just close the picker on blur
    setTimeout(() => {
      setShowDatePicker(false);
    }, 200);
  };

  return (
    <div className="relative" ref={datePickerRef}>
      <h2 
        onClick={() => setShowDatePicker(!showDatePicker)}
        className="text-lg font-medium text-gray-900 min-w-[250px] text-center cursor-pointer hover:text-gray-700"
      >
        {dateDisplay}
      </h2>
      {showDatePicker && (
        <input
          ref={inputRef}
          type="date"
          value={tempDate}
          onChange={handleDatePickerChange}
          onBlur={handleDatePickerBlur}
          className="absolute top-full mt-2 left-1/2 -translate-x-1/2 z-50 px-3 py-2 border border-gray-300 rounded-md shadow-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          autoFocus
        />
      )}
    </div>
  );
}

export default DatePicker;
